module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("j1KR4"))).then(() => parcelRequire('hEqeo'));